import apiClient from '@shared/lib/general/apiClient';
import initialState from '@shared/store/adoption/adoptionInitialState';
import {
  ADOPTION_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';

const actions = {
  changeAdoptionValues({ commit }, changes) {
    commit({
      type: ADOPTION_CHANGE_VALUES,
      changes,
    });
  },
  resetInstallFilters({ dispatch }) {
    dispatch('changeAdoptionValues', [{
      field: 'adoptionInstallFilters',
      value: [...initialState().adoptionInstallFilters],
    }]);
  },
  async getFailReasons({ rootState }) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;
    const { data } = await apiClient({
      method: 'GET',
      url: `adoption/stat/reasons/corp/${corpId}`,
    });
    return data;
  },
  async getTechnicians({ dispatch, rootState }) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;

    try {
      dispatch('changeAdoptionValues', [{
        field: 'loadingTechs',
        value: true,
      }]);
      const { data } = await apiClient({
        method: 'GET',
        url: `/adoption/stat/tech/${corpId}/overview`,
      });
      const technicians = data.filter((item) => !item.nonInstaller);
      dispatch('changeAdoptionValues', [{
        field: 'technicians',
        value: technicians,
      },
      {
        field: 'loadingTechs',
        value: false,
      }]);
    } catch (err) {
      console.error(err);
      dispatch('changeAdoptionValues', [
        {
          field: 'loadingTechs',
          value: false,
        },
      ]);
    }
  },
};

export default actions;
